import React from "react";
import { Link } from "react-router-dom";
import Button from "../components/Button";
import Hero from "../components/Hero";

export default function Home() {
  return (
    <div className="landing-page">
      <Hero />
      <div className="choose-drink">
        <div className="choose-drink-text">
          <div className="choose-txt-1">Find</div>
          <div className="choose-txt-2">Your</div>
          <div className="choose-txt-3">Drink</div>
        </div>
        <div className="button-container">
          <Button text="Surprise Me" link="/random" />
          <Button text="Let's Search" link="/search" />
        </div>
      </div>
    </div>
  );
}
